export const SharingIsCaringLocked = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="50"
    height="50"
    viewBox="0 0 50 50"
  >
    <g
      id="Sharing_is_Caring_Badge_-_Locked"
      data-name="Sharing is Caring Badge - Locked"
      transform="translate(1 -5)"
    >
      <g
        id="Achievement_Icon"
        data-name="Achievement Icon"
        transform="translate(0 6)"
      >
        <circle
          id="Ellipse_40"
          data-name="Ellipse 40"
          cx="24"
          cy="24"
          r="24"
          fill="transparent"
          stroke="#666"
          strokeLinecap="round"
          strokeWidth="2"
        />
        <g
          id="Megaphone_-_L"
          data-name="Megaphone - L"
          transform="translate(10.77 11.467)"
        >
          <path
            id="Megaphone_-_L-2"
            data-name="Megaphone - L"
            d="M25.034,13.826a.7.7,0,0,0,.139,0,2.028,2.028,0,0,0,.488-3.965V3.21a1.175,1.175,0,0,0-.463-.944,1.27,1.27,0,0,0-1.1-.217h-.042L11.571,6.269H6.13A5.5,5.5,0,0,0,4.9,17.131l2.071,8.494a1.874,1.874,0,0,0,1.818,1.446,1.992,1.992,0,0,0,.421-.05l1.065-.255a1.868,1.868,0,0,0,1.161-.839,1.843,1.843,0,0,0,.219-1.409L9.917,17.29h1.523L24.066,21.5h.042a1.407,1.407,0,0,0,.324.042,1.269,1.269,0,0,0,.766-.251,1.184,1.184,0,0,0,.471-.94V15.188a.631.631,0,0,0-1.263,0v5.122L12.455,16.317V7.284L24.411,3.256V13.2a.625.625,0,0,0,.623.623ZM10.469,24.806a.61.61,0,0,1-.076.468.631.631,0,0,1-.387.28l-1.069.263a.627.627,0,0,1-.753-.455L6.218,17.29H8.634ZM6.26,16.032H6.13a4.27,4.27,0,1,1,0-8.54h5.075v8.556Z"
            transform="translate(-0.636 -2.005)"
            fill="#666"
          />
        </g>
      </g>
    </g>
  </svg>
);

export const SharingIsCaringUnlocked = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="50"
    height="55"
    viewBox="0 0 50 55"
  >
    <defs>
      <linearGradient
        id="linear-gradient"
        x1="0.5"
        x2="0.5"
        y2="1"
        gradientUnits="objectBoundingBox"
      >
        <stop offset="0" stopColor="#d11947" />
        <stop offset="1" stopColor="#8d0034" />
      </linearGradient>
    </defs>
    <g
      id="Sharing_is_Caring_Badge_-_Unlocked"
      data-name="Sharing is Caring Badge - Unlocked"
      transform="translate(1)"
    >
      <g
        id="Achievement_Icon"
        data-name="Achievement Icon"
        transform="translate(0 6)"
      >
        <circle
          id="Ellipse_40"
          data-name="Ellipse 40"
          cx="24"
          cy="24"
          r="24"
          stroke="#8d0034"
          strokeLinecap="round"
          strokeWidth="2"
          fill="url(#linear-gradient)"
        />
        <g
          id="Megaphone_-_L"
          data-name="Megaphone - L"
          transform="translate(10.77 11.467)"
        >
          <path
            id="Megaphone_-_L-2"
            data-name="Megaphone - L"
            d="M25.034,13.826a.7.7,0,0,0,.139,0,2.028,2.028,0,0,0,.488-3.965V3.21a1.175,1.175,0,0,0-.463-.944,1.27,1.27,0,0,0-1.1-.217h-.042L11.571,6.269H6.13A5.5,5.5,0,0,0,4.9,17.131l2.071,8.494a1.874,1.874,0,0,0,1.818,1.446,1.992,1.992,0,0,0,.421-.05l1.065-.255a1.868,1.868,0,0,0,1.161-.839,1.843,1.843,0,0,0,.219-1.409L9.917,17.29h1.523L24.066,21.5h.042a1.407,1.407,0,0,0,.324.042,1.269,1.269,0,0,0,.766-.251,1.184,1.184,0,0,0,.471-.94V15.188a.631.631,0,0,0-1.263,0v5.122L12.455,16.317V7.284L24.411,3.256V13.2a.625.625,0,0,0,.623.623ZM10.469,24.806a.61.61,0,0,1-.076.468.631.631,0,0,1-.387.28l-1.069.263a.627.627,0,0,1-.753-.455L6.218,17.29H8.634ZM6.26,16.032H6.13a4.27,4.27,0,1,1,0-8.54h5.075v8.556Z"
            transform="translate(-0.636 -2.005)"
            fill="#fff"
          />
        </g>
      </g>
      <g id="Group_2669" data-name="Group 2669" transform="translate(31)">
        <circle
          id="Ellipse_55"
          data-name="Ellipse 55"
          cx="8.5"
          cy="8.5"
          r="8.5"
          fill="#008a1c"
        />
        <g
          id="Check_Mark_-_S"
          data-name="Check Mark - S"
          transform="translate(4 5.29)"
        >
          <path
            id="Check_Mark_-_S-2"
            data-name="Check Mark - S"
            d="M9.381,2.22a.442.442,0,0,0-.639,0L3.572,7.414,1.262,5.136a.442.442,0,0,0-.631,0,.459.459,0,0,0,0,.639l2.63,2.6a.483.483,0,0,0,.32.131.459.459,0,0,0,.32-.139l5.481-5.53A.451.451,0,0,0,9.381,2.22Z"
            transform="translate(-0.502 -2.083)"
            fill="#fff"
          />
        </g>
      </g>
    </g>
  </svg>
);
